import BaseApiService from './BaseApiService';

class ClassApiService extends BaseApiService {
    constructor() {
        super('classes');
    }

    async getAll() {
        const response = await this.request({ method: 'get', url: '' });
        return response && response.classes ? response.classes : [];
    }

    async updateFicBic({id, fic_brand_id, bic_brand_id, bic_from}) {
        const data = {
            fic_brand_id, bic_brand_id, bic_from,
        };
        try {
            const response = await this.request({ method: 'PUT', url: '/' + id+'/fic_bic', data });
            return response != null;

        } catch (error) {
            throw error;
        }
    }

    async resetFicBic({id, reset}) {
        const data = {
            reset,
        };
        try {
            const response = await this.request({ method: 'DELETE', url: '/' + id+'/fic_bic', data });
            return response != null;

        } catch (error) {
            throw error;
        }
    }
}

export default new ClassApiService();
